import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "container-fluid",
  id: "kt_content_agenda"
}
const _hoisted_2 = { class: "row mb-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-xl-6 d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "card-title fw-bolder fs-3 cor_texto_1 mb-1 mt-1" }, "Agenda Virtual")
  ])
], -1)
const _hoisted_4 = { class: "col-12 col-xl-6" }
const _hoisted_5 = {
  class: "d-flex flex-column flex-sm-row justify-content-end",
  id: "nav-buttons-agenda"
}
const _hoisted_6 = {
  key: 0,
  style: {"max-width":"136px"},
  class: "d-flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center me-4" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-info-circle-fill fs-2",
    style: {"color":"var(--cor_indicadores_3)"}
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold fs-7 cor_texto_2 m-0" }, "Possui serviço paralizado", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "svg-icon svg-icon-2 cor_btn_1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_12 = { class: "svg-icon svg-icon-2 cor_btn_1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-alt cor_btn_1" })
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-box-arrow-right cor_btn_1" })
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 me-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-week cor_btn_1" })
  ]),
  /*#__PURE__*/_createTextVNode(" Agendamentos ")
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 me-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-week cor_btn_1" })
  ]),
  /*#__PURE__*/_createTextVNode(" Recepção ")
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 me-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-plus cor_btn_1" })
  ]),
  /*#__PURE__*/_createTextVNode(" Programação ")
], -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "custom-tabs-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-1 me-3" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-calendar-day cor_btn_1" })
  ]),
  /*#__PURE__*/_createTextVNode(" Serviços ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_AgendamentoModal = _resolveComponent("AgendamentoModal")!
  const _component_AdicionarOutrosMecanicoModal = _resolveComponent("AdicionarOutrosMecanicoModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.modeloAgendaSelect == 'CampV1' && _ctx.servicosParalizados.length > 0 && _ctx.concessionariaInfo.usaChecklist == '147' && _ctx.programaAgenda == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
            : _createCommentVNode("", true),
          (_ctx.refTab == 'programacao' && _ctx.programaAgenda == 1 && !_ctx.loadingGlobal)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-flex justify-content-between btn_background_1 cor_btn_1 btn-sm text-nowrap ms-sm-3 mb-4 my-sm-0",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAgendamentoModal()))
              }, [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _createTextVNode(" Programar serviço "),
                _hoisted_11
              ]))
            : _createCommentVNode("", true),
          (_ctx.refTab == 'programacao' && _ctx.programaAgenda == 1 && !_ctx.loadingGlobal)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn btn-flex justify-content-between btn_background_1 cor_btn_1 btn-sm text-nowrap ms-sm-3",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openEventModalMecanico()))
              }, [
                _createElementVNode("span", _hoisted_12, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr075.svg" })
                ]),
                _createTextVNode(" Outros eventos "),
                _hoisted_13
              ]))
            : _createCommentVNode("", true),
          (_ctx.modeloCalendarName == 'HyundaiV1' && (_ctx.refTab == 'servicos' || _ctx.refTab == 'programacao') && !_ctx.loadingGlobal)
            ? (_openBlock(), _createElementBlock("button", {
                key: 3,
                class: "btn btn-flex justify-content-between btn_background_1 cor_btn_1 btn-sm text-nowrap ms-sm-3",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo(`/agenda-virtual/exibir-multiview`)))
              }, [
                _hoisted_14,
                _createTextVNode(" Multiexibição Quadro de Serviços "),
                _hoisted_15
              ]))
            : _createCommentVNode("", true),
          (_ctx.codNivel == 4 || _ctx.codNivel == 5)
            ? (_openBlock(), _createElementBlock("button", {
                key: 4,
                class: "btn btn-flex justify-content-between btn_background_1 cor_btn_1 btn-sm text-nowrap ms-sm-3",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.signOut()))
              }, [
                _hoisted_16,
                _createTextVNode(" Sair "),
                _hoisted_17
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_el_tabs, {
      type: "border-card",
      class: "demo-tabs",
      onTabClick: _ctx.changeTab,
      modelValue: _ctx.refTab,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.refTab) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modeloAgendamento && _ctx.permissions.showAgenda.includes(_ctx.codNivel))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 0,
              name: "agendamentos",
              disabled: _ctx.disableChange
            }, {
              label: _withCtx(() => [
                _hoisted_18
              ]),
              default: _withCtx(() => [
                (!_ctx.loadingGlobal && _ctx.refTab == 'agendamentos')
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modeloAgendamento), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.modeloRecepcao && _ctx.permissions.showAgenda.includes(_ctx.codNivel))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 1,
              name: "recepcao",
              disabled: _ctx.disableChange
            }, {
              label: _withCtx(() => [
                _hoisted_19
              ]),
              default: _withCtx(() => [
                (!_ctx.loadingGlobal && _ctx.refTab == 'recepcao')
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modeloRecepcao), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.modeloProgramacao && _ctx.permissions.showProgramacao.includes(_ctx.codNivel))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 2,
              name: "programacao",
              disabled: _ctx.disableChange
            }, {
              label: _withCtx(() => [
                _hoisted_20
              ]),
              default: _withCtx(() => [
                (!_ctx.loadingGlobal && _ctx.refTab == 'programacao')
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modeloProgramacao), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        (_ctx.modeloServicos && _ctx.permissions.showAgenda.includes(_ctx.codNivel))
          ? (_openBlock(), _createBlock(_component_el_tab_pane, {
              key: 3,
              name: "servicos",
              disabled: _ctx.disableChange
            }, {
              label: _withCtx(() => [
                _hoisted_21
              ]),
              default: _withCtx(() => [
                (!_ctx.loadingGlobal && _ctx.refTab == 'servicos')
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.modeloServicos), { key: 0 }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["onTabClick", "modelValue"]),
    _createVNode(_component_AgendamentoModal),
    _createVNode(_component_AdicionarOutrosMecanicoModal)
  ]))
}